import { z } from 'zod';
import { BaseEventSchema } from '../Base';

export const CartEventSchema = BaseEventSchema.extend({
  access: z.string().optional(),
  products: z.number(),
});

export enum CartInteractionEventTypes {
  CartOpen = 'interaction.cart.open',
  CartClose = 'interaction.cart.close',
  CartStartPayment = 'interaction.cart.go_to_checkout',
  CartStartPaymentMekiDoc = 'interaction.cart.go_to_checkout_mekidoc',
}

export const CartInteractionEventTrackingSchemas = {
  [CartInteractionEventTypes.CartOpen]: CartEventSchema,
  [CartInteractionEventTypes.CartClose]: CartEventSchema,
  [CartInteractionEventTypes.CartStartPayment]: BaseEventSchema,
  [CartInteractionEventTypes.CartStartPaymentMekiDoc]: BaseEventSchema,
};
